import Vue from "vue";
import Router from "vue-router";
import packages from "../modules";

import LandingPage from "../static/LandingPage.vue";
import About from "../static/About.vue";
import Contact from "../static/Contact.vue";
import Impressum from "../static/Impressum.vue";
import CookiesPolicy from "../static/CookiesPolicy.vue";
import Reparaturbonus from "../static/Reparaturbonus";
import NotFound from "../static/NotFound.vue";

Vue.use(Router);

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: "LandingPage",
            component: LandingPage,
        }, {
            path: '/ueber-uns',
            name: "About",
            component: About,
        }, {
            path: '/impressum',
            name: "Impressum",
            component: Impressum,
        }, {
            path: '/kontakt',
            name: "Contact",
            component: Contact,
        }, {
            path: "/datenschutz",
            name: "CookiesPolicy",
            component: CookiesPolicy
        }, {
            path: "/reparaturbonus",
            name: "Reparaturbonus",
            component: Reparaturbonus
        },
        ...packages.routre,

        {
            path: "/notfound?:error",
            name: "NotFound",
            component: NotFound
        }

    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    }
});
